export const defaultTheme = {
    colors: {
        primary: '#00f2ff',
        secondary: '#7000ff',
        accent: '#ff00d9',
        success: '#00ff88',
        warning: '#ffbb00',
        danger: '#ff2255',
        info: '#00ccff',
        background: '#0a0a0c',
        surface: '#151518',
        text: '#ffffff',
        muted: '#88888f',
    },
    spacing: {
        xs: '4px',
        sm: '8px',
        md: '16px',
        lg: '24px',
        xl: '32px',
        '2xl': '48px',
        '3xl': '64px',
    },
    borderRadius: {
        none: '0',
        sm: '4px',
        md: '8px',
        lg: '12px',
        xl: '16px',
        '2xl': '24px',
        full: '9999px',
    },
    fontFamily: {
        sans: 'Inter, system-ui, -apple-system, sans-serif',
        mono: 'JetBrains Mono, monospace',
        display: 'Outfit, sans-serif',
    },
    glows: {
        primary: '0 0 20px rgba(0, 242, 255, 0.3)',
        secondary: '0 0 20px rgba(112, 0, 255, 0.3)',
        accent: '0 0 20px rgba(255, 0, 217, 0.3)',
    },
    blur: {
        sm: '4px',
        md: '8px',
        lg: '16px',
        xl: '24px',
    }
}
